// these aren't super awesome. but we need something orthogonal to action name
export const OPT_USER_INITIATED = "__user_initiated";
export const OPT_USER_CONFIRMED = "__user_confirmed";

const RecordActions = {
    // create a new top-level (standalone) record.
    NEW: "record/new",
    // set a field on an existing record.
    SET_FIELD: "record/set-field",
    // create a new composed record and wire it.
    NEW_CHILD: "record/new-child",
    // delete a composed child
    DELETE_CHILD: "record/delete-child",
    // delete a top-level record (incl. magic children)
    DELETE_RECORD: "record/delete-record",
};

export default RecordActions;



// WEBPACK FOOTER //
// ./app/data/RecordActions.js